// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"868b3b08","879":"b2791e0e"}[chunkId] + ".chunk.js";
};